import styled from 'styled-components';
import { color, gutter } from '../../styles/mixins';
import { p16 } from '../../styles/typography';

export const Input = styled.input`
  ${p16};
  width: 100%;
  display: flex;
  padding: ${gutter(2)};
  border: 1px solid ${color('gray50')};
  border-radius: ${(props) => props.theme.border.radius}px;
`;
